import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAuthStore } from '../store/useAuthStore'
import { WelcomeLogin } from '../modules/auth/WelcomeLogin'

function IndexPage() {
  const { isAuthenticated } = useAuthStore()

  if (isAuthenticated) {
    return <Navigate to="/home" />
  }

  return <WelcomeLogin />
}

export const Route = createFileRoute('/')({
  component: IndexPage,
})
